import {
  GameLoaderType,
  LOADERS_WITH_HTML5_FALLBACK,
  UNITY_LOADERS_WITH_DATA_SAVE,
} from '@crazygames/game-types/src/game-build/loader.type';

/** These game loader versions display the toggles so the dev can tell us how the game saves data. */
export const loadersWithSaveDataToggles: GameLoaderType[] = [
  'html5',
  'iframe',
  ...UNITY_LOADERS_WITH_DATA_SAVE,
  ...LOADERS_WITH_HTML5_FALLBACK,
];
